<template>
    <div class="custom-name">
        <b-input-group>
            <template v-slot:prepend>
                <span
                    class="edit btn-edit text-primary btn-primary-icon-only"
                    v-if="!disabled"
                    :class="edit && 'hidden'"
                    @click="toggleEdit()">
                </span>
                <b-form-input
                    v-model="name"
                    v-on:keyup.enter="saveEdit(true)"
                    v-if="edit"
                    type="text"
                    ref="name"
                    :disabled="disabled"
                    autofocus>
                </b-form-input>
            </template>
            <b-input-group-append v-if="edit">
                <b-button
                    class="btn-checked btn-input-custom-name"
                    variant="success-icon"
                    @click="toggleEdit()"></b-button>
            </b-input-group-append>

            <span
                v-if="!edit"
                @click="toggleEdit()"
                >{{ name }}</span
            >
        </b-input-group>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-group-show-option-name-component',
        props: ['nameIn', 'optionIn', 'disabled', 'groupId'],
        data() {
            return {
                name: this.nameIn,
                option: this.optionIn,
                edit: false,
            };
        },
        methods: {
            toggleEdit: function () {
                if (!this.disabled) {
                    if (this.edit) {
                        this.saveEdit(false);
                    }

                    this.edit = !this.edit;
                }
            },
            saveEdit: function (setToggle) {
                if (setToggle) {
                    this.toggleEdit();
                }

                this.axios.post('/group/updateoptionname/' + this.groupId, {
                    option: this.option,
                    value: this.name,
                });
            },
        },
        watch: {
            disabled(value) {
                this.disabled = value;
            },
        },
    };
</script>

<style scoped lang="scss">
    .custom-name {
        display: flex;
        flex-direction: row;
        flex-wrap: unset;
        justify-content: flex-start;
        flex: 1;

        .edit {
            opacity: 1;
            align-self: center;
            cursor: pointer;

            &.hidden {
                opacity: 0;
            }
        }

        > .input-group {
            flex-wrap: nowrap;

            input {
                &,
                &:focus {
                    box-shadow: none;
                }
            }
        }

        &:focus-within {
            box-shadow: 0 0 0 0.2rem rgba(var(--primary), 0.25);
            border-radius: $border-radius-content;
            width: fit-content;
        }

        input {
            padding-top: map-get($grid-gutter-spacing, 'ten');
            padding-bottom: map-get($grid-gutter-spacing, 'ten');
            border: 1px solid $border-color;
            margin-bottom: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            &:focus ~ .btn-input-custom-name {
                box-shadow: none;
            }
        }

        .btn-input-custom-name {
            padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'ten');
            border: 1px solid $success;
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;

            &:before {
                margin-right: 0;
                align-self: center;
            }
        }
    }
</style>
